import React, { useEffect, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { IoIosSave } from "react-icons/io";
import savePromt from "./apis/savePromt";
import { toast } from "react-toastify";
import gpt from "./gpt.svg";
import getPrompt from "./apis/getPrompt";

const AI = ({ botId }) => {
  const [defaultPrompt, setDefaultPrompt] = useState("");
  const [defaultToggle, setDefaultToggle] = useState(false);

  const fnn = async () => {
    const res = await getPrompt(botId);
    setDefaultPrompt(res.data);
  };

  useEffect(() => {
    const fn = async () => {
      const res = await getPrompt(botId);
      setDefaultPrompt(res.data);
    };

    if (botId) {
      fn();
    }
  }, [botId]);

  const handleSave = async () => {
    const res = await savePromt(botId, defaultPrompt);

    if (res.error) {
      toast.error(res.msg || "Failed to update prompt.");
      return;
    }

    toast.success(res.msg || "Prompt updated successfully.");
    setDefaultToggle(false);
    await fnn();
  };

  return (
    <div className="bg-white shadow-lg text-black rounded-xl p-6  space-y-6 text-base border border-gray-200">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold">AI Settings</h2>
        <p className="text-sm text-gray-500">
          Configure your assistant’s model and behavior.
        </p>
      </div>

      {/* Model */}
      <div className="border p-4 rounded-lg bg-gray-50">
        <h3 className="font-semibold text-gray-800 mb-2">Model</h3>
        <div className="flex items-center gap-2">
          <img src={gpt} alt="GPT-4o logo" className="w-5 h-5" />
          <span className="text-gray-700 font-medium">GPT-4o</span>
          <span className="text-xs text-gray-500">(default)</span>
        </div>
      </div>

      {/* Prompt */}
      <div className="border p-4 rounded-lg bg-gray-50">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-semibold text-gray-800">
            Instruction (Prompt)
          </h3>
          {!defaultToggle && (
            <button
              onClick={() => setDefaultToggle(true)}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition">
              <CiEdit size={20} />
              Edit
            </button>
          )}
        </div>

        {!defaultToggle ? (
          <p className="whitespace-pre-wrap bg-white p-3 border rounded-md text-gray-700 hover:shadow-sm transition">
            {defaultPrompt}
          </p>
        ) : (
          <div className="space-y-4">
            <textarea
              onChange={(e) => setDefaultPrompt(e.target.value)}
              value={defaultPrompt}
              className="w-full min-h-72 p-3 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setDefaultToggle(false)}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-md text-sm">
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md text-sm font-medium transition">
                <IoIosSave size={20} />
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AI;
